// extracted by css-extract-rspack-plugin
export default {"paper":"paper-WUQZrj","title":"title-mtSvTL"};